import 'constants/constants.json';
import { ApiService } from './api.service';

export const AddressVerificationService = angular
    .module('checkout.addressVerificationService', [
        ApiService,
        'app.constants'
    ]).service('addressVerificationService', (
        apiService
    ) => {
        function isAddressVerified(address) {
            return this.verifyAddress(address)
                .then(({ verified }) => verified);
        }

        function verifyAddress(address) {
            return apiService.verifyAddress(address)
                .then(({ verificationStatus, ...rest }) => {
                    if (verificationStatus === 'Verified') {
                        const isSame = checkAddressSimilarity(address, rest);

                        if (isSame.same) return { verified: true };

                        return {
                            verified: true,
                            changes: isSame.changes
                        };
                    }

                    if (verificationStatus === 'Partial') {
                        return {
                            verified: false,
                            recommendations: rest.recommendations
                        };
                    }

                    return { verified: false };
                }).catch(() => ({
                    verified: false
                }));
        }

        function checkAddressSimilarity(enteredAddress, returnedAddress) {
            const same = {
                address1: false,
                address2: false,
                city: false,
                state: false,
                postalCode: false
            };
            const changes = {};

            // consider both eAddress1 + ' ' +  eAddress2 === rAddress1 and
            //  eAddress1 === rAddress1 to be matching
            if (`${enteredAddress.address1} ${enteredAddress.address2}` === returnedAddress.address1) {
                same.address1 = true;
                same.address2 = true;
            } else {
                same.address1 = (enteredAddress.address1 || '') === (returnedAddress.address1 || '');
                same.address2 = (enteredAddress.address2 || '') === (returnedAddress.address2 || '');
            }

            same.city = enteredAddress.city === (returnedAddress.locality || '');
            same.state = enteredAddress.state === (returnedAddress.administrativeArea || '');
            same.postalCode = enteredAddress.postalCode === (returnedAddress.postalCode || '');

            if (!same.address1) changes.address1 = returnedAddress.address1;
            if (!same.address2) changes.address2 = returnedAddress.address2;
            if (!same.city) changes.city = returnedAddress.locality;
            if (!same.state) changes.state = returnedAddress.administrativeArea;
            if (!same.postalCode) changes.postalCode = returnedAddress.postalCode;

            return {
                same: Object.values(same).every(el => el),
                changes
            };
        }

        function getAutocompleteAddressParts(placeId) {
            return apiService
                .getAutocompleteAddressParts(placeId)
                .then(parts => parts.data);
        }

        function autocompleteAddress(address, country) {
            const components = [];
            if (country) {
                components.push(`country:${country}`);
            }
            return apiService.autocompleteAddress(address, components);
        }

        const service = {
            isAddressVerified,
            getAutocompleteAddressParts,
            autocompleteAddress,
            verifyAddress
        };

        return service;
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/addressVerification.service.js